exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center {\r\n    margin-top: 25vh;\r\n}\r\n\r\n.custom-size {\r\n    width: 240px;\r\n}\r\n\r\n.custom-modal-header-successfully {\r\n\tpadding: 2px 2px 2px 2px;\r\n\ttext-align: center;\r\n\tbackground-color: #1150ae;\r\n}\r\n\r\n.custom-modal-header-failed {\r\n\tpadding: 2px 2px 2px 2px;\r\n\ttext-align: center;\r\n\tbackground-color: #E80000;\r\n}\r\n\r\n.custom-modal-header-toolbar {\r\n\tpadding: 0;\r\n}\r\n\r\n.custom-modal-header-toolbar .close {\r\n\tfont-size: 18px;\r\n\tcolor: #FFFFFF;\r\n\tfont-weight: bold;\r\n\topacity: 1;\r\n\tpadding-right: 2px;\r\n}\r\n\r\n.custom-modal-header-toolbar .close:hover {\r\n    color: #000;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    filter: alpha(opacity=50);\r\n    opacity: .5;\r\n}\r\n\r\n.custom-modal-title {\r\n\tmargin: 0;\r\n\tcolor: #FFFFFF;\r\n\ttext-align: center;\r\n\tfont-weight: bold;\r\n\tfont-size: 14px;\r\n\tfont-family: Arial;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/message-resend-modal.component.css
// module id = ../../../../../src/app/custom-modals/message-resend-modal.component.css
// module chunks = main